var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evaa---Desktop-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payments",
    transform: "translate(-860.000000, -20.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(200.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(660.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "payments_black_24dp-(1)",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,10 L18,2 C18,0.9 17.1,0 16,0 L2,0 C0.9,0 0,0.9 0,2 L0,10 C0,11.1 0.9,12 2,12 L16,12 C17.1,12 18,11.1 18,10 Z M16,10 L2,10 L2,2 L16,2 L16,10 Z M9,3 C7.34,3 6,4.34 6,6 C6,7.66 7.34,9 9,9 C10.66,9 12,7.66 12,6 C12,4.34 10.66,3 9,3 Z M22,3 L22,14 C22,15.1 21.1,16 20,16 L3,16 C3,15 3,15.1 3,14 L20,14 L20,3 C21.1,3 21,3 22,3 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsNav);
export default __webpack_public_path__ + "static/media/Payments-nav.a546ff1e8acaf21c8784eefa72aeaf6d.svg";
export { ForwardRef as ReactComponent };